const { h, render, Component } = require('preact');
const SupportAPIHelper = require('../../../../../support/frontend/helpers/API')
const touch2017Utils = require('../../../../../touch_2017/frontend/utils')

class GoodsStatus extends Component {
  constructor(props) {
    super(props);
    this.dealSuccessCallback = this.dealSuccessCallback.bind(this);
  }

  componentWillMount() {
    let order = this.props.order
    let fulfillmenturl = `${Groupon.Utils.getConfigFromDom().SUPPORTBASEURL}/orders/${order.id}/fulfillments`
    let errorCb = (response) => {
      this.setState({type: 'DEFAULT'})
    }
    let successCb = (response) => {
      if (response) {
        if(response.deliveryRange){
          this.setState({fullfillment: response, type: 'DELIVERY'})
        }
        else{
          this.fulfillmentErrorCallback()
        }
      }
    }
    SupportAPIHelper.get(fulfillmenturl, null, successCb, errorCb, false);
  }

  fulfillmentErrorCallback(){
    const currentOrder = this.props.order
    let queryParam = ""
    if(currentOrder.deal.id && currentOrder.purchasedAt)
    {
      if(currentOrder.expressDeliveryDate)
        queryParam = `&expressDeliveryDate=${currentOrder.expressDeliveryDate}`
      let url = `${Groupon.Utils.getConfigFromDom().SUPPORTBASEURL}/deal/${currentOrder.deal.id}?purchasedAt=${currentOrder.purchasedAt}`+queryParam
      let errCb = () =>{}
      SupportAPIHelper.get(url, null, this.dealSuccessCallback, errCb, false);
    }
  }

  dealSuccessCallback(deal){
    if(deal.expressDeliveryDate)
    {
      this.setState({type: 'EXPRESS_DELIVERY'})
    }
    else if(deal.deliveryRange){
      this.setState({type: 'ESTIMATED_DELIVERY'})
    }
    this.setState({deal: deal})
  }

  componentDidUpdate(){
    touch2017Utils.localizeUTCDates('MMM DD, YYYY')
  }

  render() {
    if(this.state.type=='DELIVERY'){
      return (
        <tr>
          <td> {this.state.fullfillment.deliveryRange.text}: </td>
          <td dangerouslySetInnerHTML={{__html : this.state.fullfillment.deliveryRange.dateString}} />
        </tr>
      )
    }
    else if(this.state.type=='EXPRESS_DELIVERY'){
      return (
        <tr>
          <td>{I18n.translate('js.modules.support.delivery_date')}: </td>
          <td>{this.state.deal.expressDeliveryDate} {I18n.translate('js.modules.support.express_shipping')}</td>
        </tr>
      )
    }
    else if(this.state.type=='ESTIMATED_DELIVERY'){
      return (
        <tr>
          <td>{I18n.translate('js.modules.support.estimated_delivery')}: </td>
          <td>{this.state.deal.deliveryRange}</td>
        </tr>
      )
    }
    return null;
  }
}
module.exports = GoodsStatus
